import { Alert, Box, Button, Card, CardContent, Container, Divider, Grid, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const OrderConfirmation: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderIdParam = params.get('orderId');

  const order = useMemo(() => {
    try {
      const raw = localStorage.getItem('totalbat-lastOrder');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (orderIdParam && parsed?.id !== orderIdParam) return parsed;
      return parsed;
    } catch {
      return null;
    }
  }, [orderIdParam]);

  if (!order) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ py: 6, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>Order not found</Typography>
          <Button variant="contained" onClick={() => navigate('/products')}>Browse Products</Button>
        </Box>
      </Container>
    );
  }

  const isOM = order.paymentMethod === 'om';
  const isWave = order.paymentMethod === 'wave';

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>Order Confirmation</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Order ID: {order.id}</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>Items</Typography>
                <Divider sx={{ my: 2 }} />
                {order.items.map((it: any) => (
                  <Box key={it.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2">{it.name} × {it.quantity}</Typography>
                    <Typography variant="body2">{(it.lineTotal).toLocaleString()} FCFA</Typography>
                  </Box>
                ))}
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="h6">Total</Typography>
                  <Typography variant="h6" color="primary">{(order.total).toLocaleString()} FCFA</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>Shipping</Typography>
                <Divider sx={{ my: 2 }} />
                {order.shipping ? (
                  <>
                    <Typography variant="body2">{order.shipping.firstName} {order.shipping.lastName}</Typography>
                    <Typography variant="body2">{order.shipping.address}</Typography>
                    <Typography variant="body2">{order.shipping.city} {order.shipping.postalCode}</Typography>
                    <Typography variant="body2">{order.shipping.phone}</Typography>
                    <Typography variant="body2">{order.shipping.email}</Typography>
                  </>
                ) : (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    Shipping information was not provided.
                  </Alert>
                )}
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" color="text.secondary">Payment Method</Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {order.paymentMethod === 'cod' && 'Arrive Paye'}
                  {order.paymentMethod === 'om' && 'Orange Money'}
                  {order.paymentMethod === 'wave' && 'Wave'}
                </Typography>
                {(isOM || isWave) && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Please send {(order.total).toLocaleString()} FCFA via {isOM ? 'Orange Money' : 'Wave'} to +221 77 123 45 67. We will process your order once we confirm payment.
                  </Alert>
                )}
                <Button variant="outlined" fullWidth onClick={() => navigate('/products')}>Continue Shopping</Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default OrderConfirmation;



